import LandingNavbar from "@/components/landingpage/LandingNavbar";
import Hero from "@/components/landingpage/Hero";
import HowItWorks from "@/components/landingpage/HowItWorks";
import LossCalculator from "@/components/landingpage/LossCalculator";
import Features from "@/components/landingpage/Features";
import Solutions from "@/components/landingpage/Solutions";
import Testimonials from "@/components/landingpage/Testimonials";
import Visibility from "@/components/landingpage/Visibility";
import Pricing from "@/components/landingpage/Pricing";
import FAQ from "@/components/landingpage/FAQ";
import Contact from "@/components/landingpage/Contact";
import Footer from "@/components/landingpage/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background font-sans selection:bg-primary/20">
      <LandingNavbar />
      <main>
        <Hero />
        <HowItWorks />
        <LossCalculator />
        <Solutions />
        <Features />
        <Testimonials />
        <Visibility />
        <Pricing />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
